import { BorderSides, CART_SCROLLABLE_ELEMENTS_TYPE, DISCOUNT_DISPLAY_TYPE } from 'src/components/cartV2/config'
import { CartNoteErrorType } from 'src/lib/types/cart'
import { CartButtonCTAText, CART_WIDTH_FOR_MOBILE, CartNoteType } from 'src/lib/types/cartUI'
import { CouponVisibilityExtentType } from 'src/lib/types/customizeUI'
import { BannerStateConfigType, CustomisablePageType } from 'src/lib/types/merchantAttributes'

export const DEFAULT_CART_UI_DATA = {
  showUpiIconsOnCartButton: false,
  enableMarketingFlag: false,
  cartBannerUIConfigData: {
    color: '',
    textColor: '',
    text: '',
    enabled: false
  },
  cartBottomBannerUIConfigData: {
    color: '',
    textColor: '',
    text: '',
    enabled: false
  },
  colorPaletteData: {
    primaryColor: '',
    primaryTextColor: ''
  },
  cartWidthForMobile: CART_WIDTH_FOR_MOBILE.FULL,
  couponVisibilityConfig: [
    {
      type: 'CART' as CustomisablePageType,
      areCouponsVisible: false,
      visibilityExtent: 'cards' as CouponVisibilityExtentType,
      hideSavings: false
    }
  ],
  page: {
    backgroundColor: '#FFFFFF'
  },
  header: {
    backgroundColor: '#FFFFFF',
    textColor: '#000000'
  },
  footer: {
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    savingsColor: '#2C874A',
    showSavings: true
  },
  primaryCTAConfig: {
    backgroundColor: '#000000',
    textColor: '#FFFFFF',
    borderRadius: 12,
    showUpiIcons: false,
    showUpiIconsOnCartButton: false,
    cartButtonCTAText: 'Checkout'
  },
  addonConfig: {
    backgroundColor: '#f2f2f3',
    textColor: '#3f3f46',
    buttonColor: '#3f3f46'
  },
  orderSummaryConfig: {
    backgroundColor: '#f4f4f5',
    borderColor: '#FFFFFF',
    offerBadgeColor: '#2c874a',
    textColor: '#000000',
    quantityEditorBackground: '#FFFFFF',
    quantityEditorText: '#4d4d4d',
    cardRadius: 12,
    cardBorderWidth: 0,
    cardBorderSides: 'all' as BorderSides
  },
  upsell: {
    isEnabled: false,
    title: 'Upsell',
    discountedTitle: 'Discounted Upsell',
    shouldOverrideDiscountedUpsell: false,
    backgroundColor: '#FFFFFF',
    borderColor: '#FFFFFF',
    textColor: '#000000',
    buttonColor: '#2b874a',
    offerBadgeColor: '##2b874a',
    titleColor: '#2b874a',
    cardRadius: 12,
    cardBorderWidth: 0,
    cardBorderSides: 'all' as BorderSides
  },
  notesConfig: {
    isEnabled: false,
    backgroundColor: '#FFFFFF',
    borderColor: '#E4E4E7',
    textColor: '#000000',
    buttonColor: '#2b874a',
    cardRadius: 12,
    cardBorderWidth: 0,
    cardBorderSides: 'all' as BorderSides
  },
  discountConfig: {
    displayAs: 'highlighted' as DISCOUNT_DISPLAY_TYPE,
    callout: {
      backgroundColor: '#FFFFFF',
      infoColor: '#000000',
      primaryColor: '#000000',
      borderColor: '#000000'
    },
    footer: {
      backgroundColor: '#FFFFFF',
      infoColor: '#000000',
      primaryColor: '#000000'
    },
    input: {
      backgroundColor: '#FFFFFF',
      borderColor: '#000000',
      primaryColor: '#000000'
    },
    button: {
      backgroundColor: '#000000',
      textColor: '#FFFFFF'
    },
    totalSavings: {
      primaryColor: '#000000',
      infoColor: '#000000',
      backgroundColor: '#FFFFFF'
    },
    cardRadius: 12,
    cardBorderWidth: 0,
    cardBorderSides: 'all' as BorderSides,
    buttonRadius: 12,
    filterRadius: 12
  },
  elementOrder: ['ORDER_SUMMARY', 'DISCOUNTS', 'UPSELL', 'NOTES'] as CART_SCROLLABLE_ELEMENTS_TYPE[],
  couponPageConfig: {
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    primaryColor: '#2b874a',
    cardRadius: 12,
    filterRadius: 12,
    buttonRadius: 12
  }
}

export const DEFAULT_STATE_BANNER_CONFIG: BannerStateConfigType = {
  type: 'CART',
  color: '#000000',
  textColor: '#FFFFFF',
  text: '',
  enabled: false
}

export const DEFAULT_CART_BUTTON_CTA_TEXT: CartButtonCTAText = { CTAText: 'Checkout', type: 'CART' }

export const DEFAULT_COLOR_PALETTE = {
  primaryColor: '#000000',
  primaryTextColor: '#FFFFFF'
}

export const DEFAULT_UI_CONFIG_DATA = {
  sfContext: 'CART',
  uiAttributes: {
    bannerConfig: [],
    bottomBannerConfig: [],
    colorPalette: DEFAULT_COLOR_PALETTE,
    primaryCTAConfig: [],
    cartWidthForMobile: CART_WIDTH_FOR_MOBILE.FULL
  }
}

export const DEFAULT_CART_NOTES: CartNoteType = {
  enabled: false,
  icon: 'EDIT',
  title: 'Add a note',
  suggestionText: 'Add any specific instructions or requests...'
}

export const DEFAULT_CART_NOTE_ERROR: CartNoteErrorType = {
  title: {
    errorMessage: '',
    hasError: false
  },
  suggestionText: {
    hasError: false,
    errorMessage: ''
  }
}
